import {
  useAdminCredentials,
  useRevealCredential,
  useUpdateCredentials,
} from '../../../features/admin/use-admin-credentials'
import { VENDOR_KEYS, vendorBlock } from '../../../features/admin/vendors'
import { AdminPage, Meta, VendorPanel } from './admin-bits'

export function SignalAdminCredentials() {
  const creds = useAdminCredentials()
  const update = useUpdateCredentials()
  const reveal = useRevealCredential()
  return (
    <AdminPage
      page="credentials"
      title="Credentials"
      meta={<Meta>secrets masked - reveal auto-masks 30s</Meta>}
      loading={creds.isLoading}
      error={!!creds.error}
    >
      {VENDOR_KEYS.map((v) => (
        <VendorPanel
          key={v}
          vendor={v}
          block={vendorBlock(creds.data, v)}
          pending={update.isPending && update.variables?.vendor === v}
          error={update.variables?.vendor === v ? update.error : null}
          onSave={(body) => update.mutate(body)}
          reveal={(vendor, field) => reveal.mutateAsync({ vendor, field })}
        />
      ))}
    </AdminPage>
  )
}
